import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { PUBLIC_KEY } from "../common";

export const useEmailForm = ({ serviceId, templateId, reset }) => {
  const formRef = useRef(null);
  const [status, setStatus] = useState("idle");

  const submit = async () => {
    if (!formRef.current) return;

    setStatus("loading");

    try {
      await emailjs.sendForm(
        serviceId,
        templateId,
        formRef.current,
        PUBLIC_KEY
      );
      setStatus("success");
      reset();
    } catch {
      setStatus("error");
    }
  };

  const resetStatus = () => setStatus("idle");

  return {
    formRef,
    status,
    submit,
    resetStatus,
  };
};
